<template>
  <div>
    <b-modal
      id="terminologyConfirmModal"
      hide-footer
      hide-header
      size="md"
      no-close-on-esc
      no-close-on-backdrop
      scrollable
      @hide="hideModal"
    >
      <VpConfirmModal v-if="showModal" :modalId="'terminologyConfirmModal'">
        <template v-slot:title>
          <span>Attendance Codes Terminology</span>
        </template>

        <template v-slot:text1>
          <span
            >Are you sure you want to <strong>“Save”</strong> the terminology changes for
            these attendance codes?</span
          >
        </template>

        <template v-slot:buttons>
          <VpButton
            text="Save"
            :disabled="submitted"
            :isLoading="submitted"
            @click="onSubmit()"
          />
          <VpButton
            text="Cancel"
            :disabled="submitted"
            :isDanger="true"
            @click="cancelChanges"
          />
        </template>
      </VpConfirmModal>
    </b-modal>

    <!-- START :: Attendance Code Grid  -->
    <section
      class="integration-white-bg-sec integration-table"
    >
      <PageHeader
        title="integration"
        :items="items"
        :hasHeaderButton="true"
        class="page-top-header d-flex align-items-center vp-width-270"
      >
        <template #headerButton>
          <button v-if="!isEdit" class="cursor-pointer" @click="showModal = true; isEdit = true">
            {{ $t("common.edit") }}
          </button>
          <button v-else class="cursor-pointer" @click="checkChanges">{{ $t("common.save") }}</button>
        </template>
      </PageHeader>

      <DxDataGrid
        id="dxAttCodeGride"
        :ref="dataGridRefName"
        :data-source="attendanceCodes"
        :remote-operations="false"
        :showBorders="false"
        :columnAutoWidth="true"
        :allowColumnReordering="false"
        :allowColumnResizing="true"
        :rowAlternationEnabled="false"
        :showColumnLines="true"
        :showRowLines="true"
        :wordWrapEnabled="true"
        :rtl-enabled="rtlEnabled"
        :no-data-text="'No Attendance Code Avaliable'"
        @editor-preparing="onEditorPreparing($event)"
        @content-ready="contentReady($event)"
      >
        <!-- //todo:sorting -->
        <!-- <DxStateStoring :enabled="true" type="custom"  :customSave="customSave" :customLoad="customLoad"/> -->
        <DxScrolling mode="standard" :use-native="!rtlEnabled"/>
        <DxFilterRow :visible="true" />

        <DxPaging :page-size="1000" />
        <DxHeaderFilter :visible="true" />
        <DxColumnChooser :enabled="true" mode="select" :title="$t('common.grid.columnChooser')" />
        <DxExport :enabled="true" :allow-export-selected-data="false" />
        <!-- start:: Toolbar ----------------------------------- -->
        <DxToolbar>
          <!-- <DxItem name="groupPanel"/> -->
          <DxItem template="columnButtonTemplate" location="before" />
          <DxItem template="exportButtonTemplate" location="before" />
          <DxItem template="clearAllTemplate" location="before" />
        </DxToolbar>

        <!-- start::Clear All Button Template -->
        <template #clearAllTemplate>
          <div v-if="showClearAll" class="clear-cols d-flex align-items-center">
            <div class="toolbar-custom-line"></div>
            <Button
              :text="$t('common.grid.clearFilters')"
              @click="reset"
              styling-mode="outlined"
              type="danger"
              class="clear-CustomColums"
            />
          </div>
        </template>
        <!-- end::Clear All Button Template -->

        <!-- start::Toolbar templates -->
        <template #exportButtonTemplate>
          <DxDropDownButton
            :items="buttonData"
            class="export-dropdown"
            :text="$t('common.grid.export')"
            @item-click="onItemClick"
          />
        </template>

        <template #columnButtonTemplate>
          <button class="custom-columns" @click="dataGrid.showColumnChooser()">
            <span class="custom-text">{{ $t("common.grid.columns") }} </span>

            <span class="custom-icon">
              <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
            </span>
          </button>
        </template>

        <!-- start::Toolbar templates -->
        <!-- end:: Toolbar -------------------------------------------------->
        <DxPager
          :visible="true"
          :display-mode="'full'"
          :show-page-size-selector="true"
          :show-info="true"
          :show-navigation-buttons="true"
          :infoText="$t('common.page')"
        />
        <DxHeaderFilter :visible="true" />
        <!-- <DxColumn data-field="id" caption="id" /> -->
        <DxColumn data-field="code" :caption="$t('common.code')" width="150" />
        <DxColumn data-field="description" :caption="$t('common.description')" />
        <DxColumn data-field="type" :caption="$t('common.type')" width="150" />
        <DxColumn
          data-field="attendance_code_terminology"
          :caption="$t('integrations.terminology')"
          header-cell-template="headerTemplate"
          :allow-sorting="false"
          :allow-filtering="false"
          :allow-header-filtering="true"
          :word-wrap-enabled="false"
          alignment="start"
          :min-width="450"
          cell-template="terminology-cell"
        >
          <DxHeaderFilter :dataSource="termHeaderFilter" />
        </DxColumn>

        <template #headerTemplate>
          <div class="d-flex" style="gap: 8px">
            <svg
              tabindex="0"
              v-b-tooltip
              :id="'terminology'"
              style="outline: none"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.9991 5.09274e-08C6.41689 0.00017857 4.87027 0.469523 3.55479 1.34868C2.23932 2.22784 1.21408 3.47734 0.608721 4.93916C0.00335938 6.40099 -0.154957 8.00949 0.153826 9.56128C0.46261 11.1131 1.2246 12.5384 2.34346 13.6572C3.46231 14.7759 4.88778 15.5377 6.43961 15.8463C7.99143 16.155 9.59991 15.9965 11.0617 15.391C12.5234 14.7854 13.7728 13.76 14.6518 12.4445C15.5308 11.1289 16 9.58221 16 8C16 6.94935 15.793 5.90899 15.3909 4.93832C14.9888 3.96766 14.3995 3.0857 13.6565 2.34282C12.9136 1.59994 12.0315 1.01068 11.0608 0.608699C10.0901 0.206714 9.04974 -0.000118493 7.9991 5.09274e-08ZM9.04524 12.1855C9.04524 12.463 8.93503 12.729 8.73884 12.9252C8.54265 13.1214 8.27655 13.2316 7.9991 13.2316C7.72164 13.2316 7.45554 13.1214 7.25935 12.9252C7.06316 12.729 6.95295 12.463 6.95295 12.1855V7.22104C6.95295 6.94358 7.06316 6.67748 7.25935 6.48129C7.45554 6.2851 7.72164 6.17488 7.9991 6.17488C8.27655 6.17488 8.54265 6.2851 8.73884 6.48129C8.93503 6.67748 9.04524 6.94358 9.04524 7.22104V12.1855ZM7.9991 4.86337C7.79271 4.86283 7.59111 4.8012 7.41969 4.68626C7.24828 4.57132 7.11472 4.40821 7.03587 4.21748C6.95701 4.02676 6.93639 3.81696 6.97659 3.61453C7.01679 3.4121 7.11602 3.2261 7.26177 3.07998C7.40752 2.93386 7.59326 2.83414 7.79559 2.79342C7.99791 2.7527 8.20775 2.77279 8.39868 2.85116C8.58961 2.92952 8.75307 3.06264 8.86845 3.23376C8.98383 3.40487 9.04599 3.60633 9.04706 3.81271C9.04765 3.95058 9.02095 4.0872 8.96852 4.21471C8.91609 4.34223 8.83895 4.4581 8.74154 4.55568C8.64414 4.65325 8.52839 4.7306 8.40096 4.78325C8.27354 4.8359 8.13697 4.86282 7.9991 4.86246V4.86337Z"
                fill="#787878"
              />
            </svg>
            <b-tooltip
              id="term-info"
              placement="bottomright"
              :target="'terminology'"
              triggers="click blur"
            >
              <div style="text-align: start">
                <p>
                  <b>On site:</b> The scan will be synced from Wonde to VisiPoint as a
                  "Signed in" scan.
                </p>

                <p>
                  <b>Off site:</b> The scan will be synced from Wonde to VisiPoint as a
                  "Signed out" scan.
                </p>
                <p style="margin-bottom: 0">
                  <b>Out of scope:</b> The scan will not be synced from Wonde to
                  VisiPoint.
                </p>
              </div>
            </b-tooltip>

            <span>Attendance Code Terminology</span>
          </div>
        </template>

        <template #terminology-cell="{ data }">
          <div
            class="d-flex align-items-center"
            style="margin-top: 10px; gap: 5px"
            v-b-tooltip
            :id="data.data.id"
          >
            <v-radio-group
              v-model="data.data.attendance_code_terminology"
              :disabled="!isEdit"
              @change="radioChanged(data.data)"
            >
              <v-radio
                v-for="option in termOptions"
                :key="option.value"
                :label="option.text"
                :value="option.value"
              ></v-radio>
            </v-radio-group>

            <b-tooltip
              placement="bottomright"
              :target="data.data.id"
              triggers="hover blur"
              v-if="!isEdit"
            >
              {{ $t("integrations.clickThe") }} <b>“{{ $t("common.edit") }}”</b> {{ $t("integrations.button") }}
            </b-tooltip>
          </div>
        </template>
      </DxDataGrid>
    </section>
    <!-- END   :: Attendance Code Grid  -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "@/components/page-header";
const dataGridRefName = "dataGrid";
import { default as Button } from "devextreme-vue/button";
import DxDataGrid, {
  DxColumn,
  DxPaging,
  DxPager,
  DxToolbar,
  DxFilterRow,
  DxHeaderFilter,
  DxColumnChooser,
  DxScrolling,
  DxExport,
  DxItem,
} from "devextreme-vue/data-grid";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import { exportDataGrid as exportDataGridToPdf } from "devextreme/pdf_exporter";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";

export default {
  components: {
    Button,
    PageHeader,
    DxDataGrid,
    DxToolbar,
    DxColumn,
    DxHeaderFilter,
    DxPaging,
    DxPager,
    DxFilterRow,
    DxColumnChooser,
    DxScrolling,
    DxDropDownButton,
    DxItem,
    DxExport,
  },
  data() {
    return {
      rtlEnabled: false,
      buttonData: ["Excel", "CSV", "PDF"],
      dataGridRefName,
      isEdit: false,
      submitted: false,
      showClearAll: false,
      showModal: true,
      attendanceCodes: [],
      originalAttendanceCodes: [],
      changedRows: [],
      changedTerminologyRows: [],
      termOptions: [
        { text: "On site", value: 1 },
        { text: "Off site", value: 2 },
        { text: "Out of scope", value: 3 },
      ],
      items: [
        {
          text: this.$t("sideNavbarMenu.integration.text"),
          to: { name: "addIntegration" },
        },
        {
          text: this.$route.params.integName,
          to: {
            name: "viewIntegration",
            params: {
              integId: this.$route.params.integId,
              integName: this.$route.params.integName,
            },
          },
        },
        {
          text: this.$t("integrations.attendanceCodes"),
          active: true,
        },
      ],
      termHeaderFilter: [
        {
          text: "On site",
          value: 1,
        },
        {
          text: "Off site",
          value: 2,
        },
        {
          text: "Out of scope",
          value: 3,
        },
      ],
    };
  },
  beforeMount() {
    if (this.getLanguage == 'ar') {
      this.rtlEnabled = true;
    }
    document.getElementById("preloader").style.display = "block";
    document.getElementById("status").style.display = "block";
    this.fetchData();
  },
  computed: {
    ...mapGetters("i18N",["getLanguage"]),
    dataGrid() {
      return this.$refs[this.dataGridRefName].instance;
    },
  },
  methods: {
    ...mapActions("integration", ["getSyncAttendanceCodesList", "editTerminology"]),
    fetchData() {
      this.getSyncAttendanceCodesList(this.$route.params.integId).then((data) => {
        this.attendanceCodes = data.data;
        this.originalAttendanceCodes = JSON.parse(JSON.stringify(this.attendanceCodes));
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      });
    },

    onEditorPreparing(e) {
      if (e.parentType == "filterRow") {
        e.editorOptions.placeholder = this.$t("common.grid.search");
      }
    },

    contentReady(e) {
      let sortedExp = this.getSortedColumns();
      let filterExp = e.component.getCombinedFilter();
      if (filterExp || sortedExp) {
        this.showClearAll = true;
      } else {
        this.showClearAll = false;
      }
      this.setColumnChooserPosition();
    },

    setColumnChooserPosition() {
      var columnChooserView = this.dataGrid.getView("columnChooserView");
      if (!columnChooserView._popupContainer) {
          columnChooserView._initializePopupContainer();
          columnChooserView.render();
      }
      columnChooserView._popupContainer.option("position", {
        of: this.dataGrid.element(),
        my: this.rtlEnabled ? "right top" : "left top",
        at: this.rtlEnabled ? "right top" : "left top",
        offset: "0 50",
      });
    },

    getSortedColumns() {
      let allColumns = Array.from(
        Array(this.dataGrid.columnCount()).keys()
      ).map((index) => this.dataGrid.columnOption(index));
      allColumns = allColumns.find((col) => col.sortIndex != null);
      return allColumns;
    },

    reset() {
      this.dataGrid.clearFilter("row");
      this.dataGrid.clearFilter("header");
      this.dataGrid.clearSorting();
      this.showClearAll = false;
    },

    onItemClick(e) {
      if (e.itemData == "Excel") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");
        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: ({ gridCell, excelCell }) => {
            if (gridCell.rowType === "data") {
              if (gridCell.column.dataField === "attendance_code_terminology") {
                if (gridCell.value == 3) excelCell.value = "Out of scope";
                else if (gridCell.value == 2) excelCell.value = "Off site";
                else if (gridCell.value == 1) excelCell.value = "On site";
                excelCell.font = { name: "Arial", size: 12 };
                excelCell.alignment = { horizontal: "left" };
              }
            }
          },
        }).then(function () {
          workbook.xlsx.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Attendance_codes.xlsx"
            );
          });
        });
        // e.cancel = true;
      } else if (e.itemData == "CSV") {
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet("Main sheet");

        exportDataGrid({
          component: this.dataGrid,
          worksheet: worksheet,
          customizeCell: ({ gridCell, excelCell }) => {
            if (gridCell.rowType === "data") {
              if (gridCell.column.dataField === "attendance_code_terminology") {
                if (gridCell.value == 3) excelCell.value = "Out of scope";
                else if (gridCell.value == 2) excelCell.value = "Off site";
                else if (gridCell.value == 1) excelCell.value = "On site";
                excelCell.font = { name: "Arial", size: 12 };
                excelCell.alignment = { horizontal: "left" };
              }
            }
          },
        }).then(function () {
          workbook.csv.writeBuffer().then(function (buffer) {
            saveAs(
              new Blob([buffer], { type: "application/octet-stream" }),
              "Attendance_codes.csv"
            );
          });
        });
      } else if (e.itemData == "PDF") {
        const doc = new jsPDF("landscape");
        exportDataGridToPdf({
          jsPDFDocument: doc,
          component: this.dataGrid,
          customizeCell: function (options) {
            const { gridCell, pdfCell } = options;
            if (gridCell.rowType === "data") {
              pdfCell.styles = {
                // font: "times",
                // fontStyle: "lato",
                fontSize: 8,
                cellWidth: "auto",
              };
              if (gridCell.column.dataField === "attendance_code_terminology") {
                if (gridCell.value == 3) pdfCell.content = "Out of scope";
                else if (gridCell.value == 2) pdfCell.content = "Off site";
                else if (gridCell.value == 1) pdfCell.content = "On site";
              }
            }
          },
        }).then(() => {
          doc.save("Attendance_codes.pdf");
        });
      }
    },

    radioChanged(data) {
      const rowExist = this.changedRows.find((item) => item.id == data.id);
      if (!rowExist) {
        this.changedRows.push({
          id: data.id,
          attendance_code_terminology: data.attendance_code_terminology,
        });
      } else {
        rowExist.attendance_code_terminology = data.attendance_code_terminology;
      }
    },

    checkChanges() {
      this.showModal = true;
      const changedTerminologyRows = this.changedRows.filter((changedRow) => {
        const originalRow = this.originalAttendanceCodes.find(
          (orig) => orig.id === changedRow.id
        );

        return (
          originalRow &&
          originalRow.attendance_code_terminology !==
            changedRow.attendance_code_terminology
        );
      });

      if (changedTerminologyRows.length == 0) this.isEdit = false;
      else {
        this.changedTerminologyRows = changedTerminologyRows;
        this.$bvModal.show("terminologyConfirmModal");
      }
    },

    cancelChanges() {
      this.attendanceCodes = JSON.parse(JSON.stringify(this.originalAttendanceCodes));
      this.changedRows = [];
      this.changedTerminologyRows = [];
      this.isEdit = false;
      this.$bvModal.hide('terminologyConfirmModal');
    },

    onSubmit() {
      this.submitted = true;
      this.editTerminology(this.changedTerminologyRows).then(() => {
        this.fetchData();
        this.$bvModal.hide("terminologyConfirmModal");
        this.isEdit = false;
        this.submitted = false;
      });
    },

    hideModal() {
      setTimeout(() => this.showModal = false, 100);
    },
  },
};
</script>

<style lang="scss">
.integration-table {
  .dx-column-indicators {
    float: inline-end !important;
  }
  .breadcrumb-item a {
    color: #4a4a4a;
  }
  .page-top-header {
    width: auto !important;
  }
  ol {
    margin: 0 !important;
    padding-inline-start: 24px !important;
    padding-inline-end: 0 !important;
  }
  .breadcrumb a {
    padding: 0;
  }
}
div#term-info .tooltip-inner {
  width: 224px !important;
  max-width: unset !important;
}
</style>
